export const clearPhoneMask = (phone: string) => {
  const trimmed = phone.trim();

  return trimmed
    .replace(/[^\d+]/g, '')
    .replace(/(?!^)\+/g, ''); 
};